import React from 'react';
var ThemeContext = React.createContext(null);
export default ThemeContext;